import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { FavoriteButton } from '../../components';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  const listingId = listing?.id?.uuid;
  const authorId = listing?.author?.id?.uuid;
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
      {listingId ? (
        <FavoriteButton
          listingId={listingId}
          authorId={authorId}
          className={css.galleryFavoriteButton}
        />
      ) : null}
    </section>
  );
};

export default SectionGallery;
